import { apiLoad } from './apiLoad';
import { set } from './set';

/*
 * Load messages from local store or api and
 * change messages for intl, and messagesStore
 * Always tries to fetch fresh translations from API first to ensure latest updates
 */
async function load(value: availableLocales) {
  // Always check for fresh translations from API first
  try {
    await apiLoad(value);
    // If API load successful, set the fresh translations
    if (await set(value)) {
      return;
    }
  } catch (error) {
    console.warn('Failed to load fresh translations from API, falling back to cache:', error);
  }

  // Fallback to cached translations if API fails
  if (await set(value)) {
    return;
  }

  // If everything fails, this shouldn't happen but handle gracefully
  console.error('Failed to load translations from both API and cache');
}

export { load };
